import React, {useEffect, useMemo} from 'react';
import {useSearchParams} from 'react-router-dom';
import {TextField} from '@mui/material';

export const SearchInput: React.FC<{
  setSearch: (val: string) => void;
  search: string;
}> = ({setSearch, search}) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const urlSearch = useMemo(() => {
    const params = new URLSearchParams(searchParams);
    const searchVal = params.get('search');
    if (searchVal) {
      return searchVal;
    }
    return null;
  }, [searchParams]);

  useEffect(() => {
    if (urlSearch) {
      setSearch(urlSearch);
    }
  }, [urlSearch]);

  useEffect(() => {
    if (search) {
      setSearchParams({search});
    }
  }, [search]);

  return (
    <>
      <TextField
        fullWidth
        value={search}
        autoFocus
        onChange={(e) => setSearch(e.target.value)}
        placeholder="Search"
      />
    </>
  );
};
